<div class="tw-flex tw-flex-col tw-gap-6 tw-w-full">
  <!-- Current Plan vs New Plan Comparison (First shadow div) -->
  <div
    class="tw-flex tw-flex-col tw-gap-4 tw-w-full tw-p-4 tw-rounded-2xl tw-shadow-elevation-card"
  >
    <div class="tw-flex tw-w-full tw-gap-4 sm:tw-flex-col">
      <!-- Current Plan -->
      <ng-container
        *ngTemplateOutlet="
          planDisplay;
          context: {
            label: 'Current Plan',
            labelClass: 'tw-text-dt-text-secondary',
            plan: currentPlan().plan,
            priceClass: 'tw-text-dt-text-headings',
          }
        "
      ></ng-container>

      <!-- New Plan -->
      <ng-container
        *ngTemplateOutlet="
          planDisplay;
          context: {
            label: 'New Plan',
            labelClass: 'tw-text-dt-text-secondary',
            plan: newPlan().plan,
            priceClass: 'tw-text-dt-text-headings',
          }
        "
      ></ng-container>
    </div>
  </div>

  <!-- Billing Date + Payment Method (Second shadow div) -->
  <div
    class="tw-flex tw-flex-col tw-gap-4 tw-w-full tw-p-4 tw-rounded-2xl tw-shadow-elevation-card"
  >
    <!-- Next Billing Date Info -->
    <div class="tw-flex tw-gap-3 tw-w-full">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-p-3 tw-rounded-xl tw-bg-dt-surface-page tw-w-[48px] tw-h-[48px] tw-aspect-square"
      >
        <icon [size]="6" [name]="'calendar'" [currentColor]="'dt-text-action'"></icon>
      </div>
      <div class="tw-flex tw-flex-col tw-gap-1 tw-flex-1">
        <span
          class="tw-font-semibold tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-secondary"
          >Next billing date</span
        >
        <span
          class="tw-font-medium tw-text-[24px] tw-tracking-normal tw-leading-[125%] tw-text-dt-text-headings"
          >{{ newBillingDate() }}</span
        >
        <span
          class="tw-font-medium tw-text-[14px] tw-tracking-normal tw-leading-[125%] tw-text-dt-text-secondary"
          >Your new plan will start on this date.</span
        >
      </div>
    </div>

    <!-- Separator line -->
    <div class="tw-flex tw-w-full tw-h-[1px] tw-border tw-border-color-border-subtle"></div>

    <!-- Payment Method Display -->
    <div class="tw-flex tw-gap-4 tw-w-full">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-p-3 tw-rounded-xl tw-bg-dt-surface-page tw-w-[48px] tw-h-[48px] tw-aspect-square"
      >
        <icon [size]="6" [name]="'star-bundle-activeSub'" [currentColor]="'dt-text-action'"></icon>
      </div>
      <div class="tw-flex tw-flex-col tw-gap-1 tw-flex-1">
        <span
          class="tw-font-semibold tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-secondary"
          >Payment method</span
        >
        <span
          class="tw-font-medium tw-text-[16px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-headings"
          >{{ selectedPaymentMethod() === "add" ? "Add payment method" : "Skip for now" }}</span
        >
        <span
          class="tw-font-medium tw-text-[14px] tw-tracking-normal tw-leading-[125%] tw-text-dt-text-secondary"
          >{{
            selectedPaymentMethod() === "add" ? "Redirects to Stripe" : "Add within 14 days"
          }}</span
        >
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="tw-flex tw-gap-4 tw-w-full sm:tw-flex-col">
    <!-- Cancel Button -->
    <button
      class="tw-flex tw-flex-1 tw-items-center tw-justify-center tw-py-4 tw-rounded-[50px] tw-transition-all tw-shadow-elevation-control tw-duration-200 hover:tw-bg-dt-surface-page"
      (click)="close()"
    >
      <span
        class="tw-font-medium tw-text-[16px] tw-tracking-[0.5%] tw-leading-[135%] tw-text-dt-text-headings"
        >Cancel</span
      >
    </button>

    <!-- Confirm Switch Button -->
    <button
      class="tw-flex tw-flex-1 tw-items-center tw-justify-center tw-py-4 tw-rounded-[50px] tw-bg-dt-surface-on-action tw-shadow-elevation-cta-glow tw-transition-all tw-duration-200 hover:tw-scale-[1.01] active:tw-scale-[0.99]"
      (click)="handleConfirm()"
    >
      <span
        class="tw-font-medium tw-text-[16px] tw-tracking-[0.5%] tw-leading-[135%] tw-text-color-text-on-action"
        >Confirm Switch</span
      >
    </button>
  </div>
</div>

<ng-template
  #planDisplay
  let-label="label"
  let-labelClass="labelClass"
  let-plan="plan"
  let-priceClass="priceClass"
>
  <div class="tw-flex tw-flex-1 tw-flex-col tw-gap-2">
    <span
      class="tw-font-semibold tw-text-[14px] tw-leading-[125%] tw-tracking-[1.25%] tw-uppercase"
      [ngClass]="labelClass"
      >{{ label }}</span
    >
    <div class="tw-flex tw-items-center tw-gap-4">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-p-3 tw-rounded-xl tw-bg-dt-surface-today-secondary tw-w-[48px] tw-h-[48px] tw-aspect-square"
      >
        <icon [name]="'bank-primary'" [size]="6"></icon>
      </div>
      <div class="tw-flex tw-flex-col tw-gap-1">
        <span
          class="tw-font-bold tw-text-[16px] tw-leading-[125%] tw-tracking-normal tw-text-dt-text-headings"
          >{{ marketLabel() }}</span
        >
        <div class="tw-flex tw-items-baseline tw-gap-1">
          <span
            class="tw-font-medium tw-text-[18px] tw-leading-[125%] tw-tracking-[0.25%] tw-font-D-DIN-PRO"
            [ngClass]="priceClass"
            >{{ plan.feeAmount }}</span
          >
          <span
            class="tw-font-medium tw-text-[14px] tw-leading-[125%] tw-tracking-[0.4%] tw-text-dt-text-secondary"
            >{{ plan.paymentCycle }}</span
          >
        </div>
      </div>
    </div>
  </div>
</ng-template>
